import React, {useState} from 'react';
import { Grid,Paper, Avatar, TextField, Button, Typography,Link, Alert } from '@mui/material'
import { auth, db } from '../../firebase/firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';


const LoginScreen = (props) => {

  const paperStyle = { padding: 20, width: 300, margin: "200px auto" }
  const avatarStyle={backgroundColor:'#39aa28'}
  const btnstyle={margin:'8px 0'}
  const textStyle={margin:'4px 0'}

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState(null)

  const navigate = useNavigate();

  const procesarDatos = (e) =>{
    e.preventDefault();

    if(!email.trim()){
      setError('Ingresar email');
      return
    }

    if(!password.trim()){
      setError('Ingresar contraseña');
      return
    }

    /* console.log('Pasando todas las validaciones'); */
    setError(null);
    logearUsuario();
  }
  
  
  const logearUsuario = async() =>{
    
    signInWithEmailAndPassword(auth, email, password)
    .then((userCredential) => {
      // Signed in
      const user = userCredential.user;
      // ...
      setEmail('')
      setPassword('')
      setError(null)

      navigate('/');
    })
    .catch((error) => {
      const errorCode = error.code;
      const errorMessage = error.message;
      /* console.log(errorCode); */
      if(errorCode==='auth/invalid-email'){
        setError('Correo no válido')
      }
      if(errorCode==='auth/user-not-found' || errorCode==='auth/wrong-password'){
        setError('Credenciales no válidas')
      }
    });
  }
  
  return (
    <>
      <Grid>
        <Paper elevation={10} style={paperStyle}>
          <Grid align='center'>
            <Avatar style={avatarStyle}>{/* {<AccountCircleIcon/>} */}</Avatar>
            <h2>Iniciar Sesión</h2>
          </Grid>
          { 
            error && (
              <Alert severity="error" >{error}</Alert>
            )
          }
          <TextField 
            style={textStyle} 
            label='Correo' 
            placeholder='Correo' 
            fullWidth 
            required
            onChange={(e)=>{setEmail(e.target.value)}}
            value={email}
          />
          <TextField 
            style={textStyle} 
            label='Contraseña' 
            placeholder='Contraseña' 
            type='password' 
            fullWidth 
            required
            onChange={(e)=>{setPassword(e.target.value)}}
            value={password}
          />

          <Button 
            type='submit' 
            color='primary' 
            variant="contained" 
            style={btnstyle} 
            fullWidth
            onClick={procesarDatos}
          >
            Entrar
          </Button>

          <Typography>
            <Link /* href="/reset" */ onClick={()=>{navigate('/reset')}}>
              Olvidé mi contraseña
            </Link>
          </Typography>
          <Typography > No tienes cuenta? 
            <Link /* href="/register"  */onClick={()=>{navigate('/register')}}>
              Registrate!
            </Link>
          </Typography>
        </Paper>
      </Grid>
    </>
  )
}

export default LoginScreen